







































import Vue, { PropType } from "vue";
import AuctionTimeChart from "@/features/home/components/auctionTimeChart.vue";
import NoData from "@/features/home/components/noData.vue";
import { AuctionTime } from "@/features/home/types";
import { SCALE_TYPE } from "@/features/home/enums";

export default Vue.extend({
  components: {
    "auction-time-chart": AuctionTimeChart,
    "no-data": NoData,
  },
  props: {
    loading: { type: Boolean, required: true },
    isNoData: { type: Boolean, required: true },
    hasMissingData: { type: Boolean, required: true },
    chartData: {
      type: Object as PropType<AuctionTime>,
      required: true,
    },
  },
  data() {
    return {
      scaleTypes: [
        SCALE_TYPE.LINEAR,
        SCALE_TYPE.LOGARITHMIC,
      ] as typeof SCALE_TYPE[keyof typeof SCALE_TYPE][],
      scaleTypesInput: "linear" as typeof SCALE_TYPE[keyof typeof SCALE_TYPE]["value"],
    };
  },
});
